function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.83 15.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4.37.75v3.53H.75V.75h3.62Zm0,3.53h3.6V.75h-3.6v3.53Zm0,0v3.55h3.6v-3.55h-3.6Zm0,0H.75v3.55h3.62v-3.55Zm0,3.55v3.58h3.6v-3.58h-3.6Zm0,0H.75v3.58h3.62v-3.58Zm0,3.58v3.65h3.6v-3.65h-3.6Zm0,0H.75v3.65h3.62v-3.65Zm3.6,3.65h7.1V4.28h-7.1v10.78Zm0-7.22h3.46v-3.56h-3.46v3.56Zm3.46,0h3.64v-3.55h-3.64v3.55Zm0,0v3.58h3.64v-3.58h-3.64Zm0,3.58v3.65h3.64v-3.65h-3.64Zm-3.46,3.65h3.46v-3.65h-3.46v3.65Zm0-3.65h3.46v-3.58h-3.46v3.58Z",
    style: {
      fill: "none",
      stroke: "#0733ed",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSite);
export default __webpack_public_path__ + "static/media/Site.05cc650625b443f117632e0de3e7d22a.svg";
export { ForwardRef as ReactComponent };